<template>
  <div
      class="sm-main-scroll-wrapper"
      :class="{'sm-hidden' : curMode === 'start'}"
  >

    <FoundInCategories v-if="totalHits > 0"></FoundInCategories>

    <div class="sm-main">
      <div class="sm-wrapper">
        <div class="sm-main-wrapper">
          <div v-if="totalHits > 0" class="sm-main__facets">

            <facets-container></facets-container>

          </div>
          <div class="sm-main__results" style="position: relative;">

            <div class="sm-main-results-actions" v-show="totalHits">
              <Tips></Tips>
              <Sort></Sort>
            </div>
            <div class="sm-products">

              <NotFound v-if="isWasSearch && !totalHits"></NotFound>
              <div class="sm-title" v-if="!totalHits">Популярные товары</div>

              <ProductsGrid container_class="sm-products-grid_horde" />

              <back-to-top
                  visibleoffset="100"
                  bottom="50px" right="50px"
                  scrollContainer=".sm-main-scroll-wrapper"
                  >
                <button class="sm-scroll-up">
                  Наверх
                  <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" class="sm-scroll-up__icon"><path d="M0.29297 7.293L1.70697 8.707L5.99997 4.414L5.99997 14L7.99997 14L7.99997 4.414L12.293 8.707L13.707 7.293L6.99997 0.586L0.29297 7.293Z"></path></svg>
                </button>
              </back-to-top>

              <infinite-loading
                  force-use-infinite-wrapper=".sm-main-scroll-wrapper"
                  @infinite="loadMore"
                  :infinite-scroll-disabled="isLoading"
                  ref="InfiniteLoading"
                  :distance=250
              >
                <div slot="no-more"></div>
                <div slot="no-results"></div>
              </infinite-loading>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FacetsContainer from './facets/facets-container.vue';
import ProductsGrid from './grid/products-grid.vue';
import FacetCategories from './facets/facet-categories.vue';
import Facets from './facets/facets.vue';
import Sort from './grid/sort.vue';
import FoundInCategories from './facets/found-in-categories.vue';
import NotFound from './facets/not-found.vue';
import Tips from './grid/tips.vue';

import FacetSlider from './facets/facet-slider.vue';

import {mapGetters, mapActions} from "vuex";
import BackToTop from './grid/backtotop.vue'
import InfiniteLoading from 'vue-infinite-loading';

export default {
name: "sm-main-scroll-wrapper",
  computed: {
    ...mapGetters("search", [
      "mode",
      "search",
      "currentPage",
      "pageSize",
      "totalHits",
      "isWasSearch",
      "queryFilters"
    ]),
    isLoading() {
      return this.$store.getters.loading;
    },
    curMode: function () {
      return this.mode
    }
  },
  watch: {
    queryFilters: {
      deep: true,
      handler: 'onFilterChanged'
    }
  },
  methods: {
    ...mapActions("search", ["doSearch", "setCurrentPage", "setDoSearchAddMore"]),
    loadMore: function($state) {

      let currentPage = this.currentPage+1;

      if(currentPage * this.pageSize > this.totalHits) {
        // сообщаем компоненте infinite-loading что все записи выведены
        $state.complete()
        return;
      }
      this.setCurrentPage(currentPage);
      this.setDoSearchAddMore(true);

      this.doSearch()
      .then(() => {
        $state.loaded()
      })
      .catch(err => {
        console.log(err.response.statusText)
      })
    },
    onFilterChanged: function () {
      if(this.$refs.InfiniteLoading){
        // сброс состояния компоненты infinite-loading
        this.$refs.InfiniteLoading.stateChanger.reset();
      }
    },
    /*handleScroll: function (evt, el) {
      console.log('handleScroll', el)
      //value: e.config.positionSelector && e.checkScroll, expression: "config.positionSelector && checkScroll" }


      if (window.scrollY > 50) {
        el.setAttribute(
            'style',
            'opacity: 1; transform: translate3d(0, -10px, 0)'
        )
      }
      return window.scrollY > 100
    }*/
  },
  /*created() {
    console.log('scroll added')
    //window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    console.log('scroll removed')
    //window.removeEventListener('scroll', this.handleScroll);
  },*/
  components: {
    FoundInCategories,
    NotFound,
    ProductsGrid,
    FacetCategories,
    Facets,
    Sort,
    Tips,
    FacetSlider,
    BackToTop,
    InfiniteLoading,
    FacetsContainer
  }
}
</script>